import { render, staticRenderFns } from "./ContactInformationPage.vue?vue&type=template&id=2323b088&"
import script from "./ContactInformationPage.vue?vue&type=script&lang=js&"
export * from "./ContactInformationPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactInformationPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports